import { render, staticRenderFns } from "./DetailsFreeDays.vue?vue&type=template&id=3b17d278&scoped=true&"
import script from "./DetailsFreeDays.vue?vue&type=script&lang=js&"
export * from "./DetailsFreeDays.vue?vue&type=script&lang=js&"
import style0 from "./DetailsFreeDays.vue?vue&type=style&index=0&id=3b17d278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b17d278",
  null
  
)

export default component.exports